import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack, FDImage, FDHeadlineText, FDDisplayText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';

export const InterstitialHeadline = ({ showFac = false, titles = [], size = 'lg' }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const TitleComponent = isMobile ? FDHeadlineText : FDDisplayText;

  if (!titles || titles.length === 0) return null;

  return (
    <FDStack direction={'column'} spacing={2} flex={1} width={'100%'} alignItems={'center'} justifyContent={isMobile ? 'center' : undefined}>
      {showFac && resource.withRelationship(fr.relationships.facetIcon.name,
        (rel) => (
          <FDImage
            src={rel.link('related').url()}
            alt={rel.meta('altText') || ''}
            aspectRatio={rel.meta('aspectRatio')}
            maxHeight={'40px'}
            rounded={false}
          />
        ),
        () => null)}
      {titles.map((title) => (
        <TitleComponent size={size} align={'center'} value={title} />
      ))}
    </FDStack>
  );
};

InterstitialHeadline.propTypes = {
  showFac: PropTypes.bool,
  titles: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.string,
};
